module.exports = {
  "country": "UA",
  "artist": "Kalush Orchestra",
  "song": "Stefania",
  "year": "2022",
  "place": "1",
  "spotify": "2vHzOWRKYPLu8umRPIFuOq"
};